let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b8Grl")).then(() => parcelRequire('9EZrH'));